import { Listing } from 'models/Listing';
import { createContext } from 'react';
import utils from 'utils';

type DraftListingContextProps = {
  draftListing: Listing;
  hasDraftBanner: boolean;
  removeDraftListing: () => void;
};

export default createContext<Partial<DraftListingContextProps>>({
  draftListing: null,
  hasDraftBanner: false,
  removeDraftListing: utils.noop,
});
